// extracted by mini-css-extract-plugin
module.exports = {"ratingNumber":"az_wKc","ratingReviews":"az_xKc","ratingsContainer":"az_yKc"};